import { render, staticRenderFns } from "./note_body.vue.js?vue&type=template&id=d279de62&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./note_body.vue?vue&type=template&id=d279de62&vue3"
import script from "./note_body.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./note_body.vue?vue&type=script&lang=js&vue3"
export * from "./note_body.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./note_body.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports